/* eslint-disable */
import { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

import { Button, Modal, CardContent, TextField } from '@mui/material';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { getEquipmentsById, patchEquipmentRemark } from "components/axios/equipmentAxios";
import MainCard from 'components/MainCard';
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import Chip from '@mui/material/Chip';

const EquipmentRemarkModifyLayer = ({equipmentId, setIsLoading}) => {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const { role } = useEnumApi();
    const [remark, setRemark] = useState(null);
    const { register, handleSubmit, formState : {isDirty, errors } } = useForm({});
    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const handleOpen = () => {
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    const onSubmit = (data) => {
        if (equipmentId) {
            const body = {
                id : equipmentId,
                remark : data.remark
            }

            openModal(modals.confirmModal, {
                onSubmit : (value) => {
                    patchEquipmentRemark(body).then(()=>{
                        alertMessage = t('message.common.alert.modify.done');
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                        setIsLoading(false);
                        handleClose();
                    }).catch((err)=>{
                        console.log(err);
                        if (!err.response?.data?.message) {
                            alertMessage = err.message;
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                        } else if (err.response.data.message) {
                            alertMessage = err.response.data.message;
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                        }
                    });
                },
                onClose : () => {
                    console.log('close');
                },
                message: t('message.common.alert.modify.question'),
            });
        }
    }

    useEffect(() => {
        if (equipmentId) {
            getEquipmentsById(equipmentId).then((data)=>{
                if (data) {
                    setRemark(data.remark);
                } else {
                    setRemark(null);
                }
            })
        }
    },[equipmentId]);

    if (equipmentId && (role === ROLE.SA.code || role === ROLE.WA.code || role === ROLE.MA.code)) {
        return (
            <>
                <div style={{minWidth:"100px",margin:"auto"}}>
                    <Button variant="contained" style={{padding:"2px 5px"}} onClick={handleOpen} >{t('message.common.btn.modify')}</Button>
                </div>
                <Modal className="pop_box" open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <MainCard modal darkTitle content={false} style={{padding:"10px"}}>
                        <div style={{display:"flex", alignItems: "center", justifyContent: "space-between", margin: "5px 0 10px 0"}}>
                            <div>
                                <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/popbullet.png`} alt='' /></span>&nbsp;
                                <Chip label={t('message.common.chip.remark.modify')} color="success" />
                            </div>
                        </div>

                        <div style={{color:"red",fontWeight:"bold",textAlign:"left"}}>* [{t('message.common.title.comprehensive.report.8.maintenance.main.communication.reflected')}]</div>
                        <CardContent style={{width:"600px",height:"100%",margin:"5px"}}>
                            <div style={{padding:"10px"}}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <TextField id="outlined-basic" 
                                        aria-invalid={!isDirty ? undefined : errors.remark ? "true" : "false"}
                                        defaultValue={remark || ''}
                                        multiline
                                        rows={3}
                                        sx={{ minWidth: '100%',  backgroundColor: "#fff" }}
                                        {...register("remark", {
                                           required : t('message.common.error.text.remark.input')
                                        })} 
                                    />
                                    {errors.remark && <small role="alert"><br></br>{errors.remark.message}</small>}
                                </form>
                            </div>
                            <div className='pop_close' style={{padding:"5px"}}>
                                <Button variant="contained" color="primary" size="small" onClick={handleSubmit(onSubmit)}>
                                    {t('message.common.btn.modify')}
                                </Button>&nbsp;
                                <Button variant="contained" color="primary" size="small" onClick={handleClose}>
                                    {t('message.common.btn.close')}
                                </Button>
                            </div>
                        </CardContent> 
                    </MainCard>
                </Modal>
                </>
        )
    }
}

export default EquipmentRemarkModifyLayer;